import { useState } from "react";
import Board from "@/components/board/Board";
import Toolbar from "@/components/board/Toolbar";
import Legend from "@/components/board/Legend";
import SidePanel from "@/components/panel/SidePanel";
import CategoryDialog from "@/components/panel/CategoryDialog";

export default function ConspiracyBoard() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [editingCardId, setEditingCardId] = useState(null);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);

  const openNewCard = () => {
    setEditingCardId(null);
    setPanelOpen(true);
  };
  const openEditCard = (id) => {
    setEditingCardId(id);
    setPanelOpen(true);
  };
  const closePanel = () => {
    setPanelOpen(false);
    setEditingCardId(null);
  };

  return (
    <div
      className="relative w-screen h-screen overflow-hidden cork-board vignette grain"
      data-testid="conspiracy-board-root"
    >
      <Toolbar
        onAdd={openNewCard}
        onManageCategories={() => setCategoryDialogOpen(true)}
      />
      <Board onEditCard={openEditCard} />
      <Legend onManageCategories={() => setCategoryDialogOpen(true)} />
      <SidePanel
        open={panelOpen}
        onClose={closePanel}
        editingCardId={editingCardId}
        setEditingCardId={setEditingCardId}
        onManageCategories={() => setCategoryDialogOpen(true)}
      />
      <CategoryDialog
        open={categoryDialogOpen}
        onOpenChange={setCategoryDialogOpen}
      />
      {/* Corner brand (top-left, subtle) */}
      <div className="absolute top-4 left-6 z-10 pointer-events-none">
        <div className="noir-title text-[#f4d9a8]/60 text-base leading-none">
         
        </div>
        <div className="typewriter text-[#c9b285]/40 text-[9px] tracking-widest uppercase">
    
        </div>
      </div>
    </div>
  );
}
